module.exports = __webpack_public_path__ + "img/gc_country_flag_fi.7fa55750.svg";